import { createSlice } from "@reduxjs/toolkit";

export const ownersSlice = createSlice({
  name: "ownersReducer",
  initialState: {
    ownerSearchParams: null,
    searchProductOwnershipResult: null,
    ownershipInquiryResult: null,
    selectedOwner: null,
    asOfBalanceAccountData: null,
    accountValueDatasource: null,
    hasSearchedForAsOfBalanceAccountData: false,
    transactionDetailsForDateRange: null,
    editProjectionsResponse: null,
    projectionsData: [],
    moneySourceDetailsValues: null,
    spouseDetails: null,
  },
  reducers: {
    setOwnerSearchParams: (state, action) => {
      state.ownerSearchParams = action.payload;
    },
    setSearchProductOwnershipResult: (state, action) => {
      state.searchProductOwnershipResult = action.payload;
    },
    setOwnershipInquiryResult: (state, action) => {
      state.ownershipInquiryResult = action.payload;
    },
    setSelectedOwner: (state, action) => {
      state.editProjectionsResponse = null;
      state.projectionsData = [];
      state.asOfBalanceAccountData = null;
      state.accountValueDatasource = null;
      state.hasSearchedForAsOfBalanceAccountData = false;
      state.moneySourceDetailsValues = null;
      state.spouseDetails = null;
      state.transactionDetailsForDateRange = null;
      state.selectedOwner = action.payload;
    },
    setAsOfBalanceAccountData: (state, action) => {
      state.asOfBalanceAccountData = action.payload;
    },
    setAccountValueDataSource: (state, action) => {
      state.accountValueDatasource = action.payload;
    },
    setHasSearchedForAsOfBalanceAccountData: (state, action) => {
      state.hasSearchedForAsOfBalanceAccountData = action.payload;
    },
    setTransactionDetailsForDateRange: (state, action) => {
      state.transactionDetailsForDateRange = action.payload;
    },
    setEditProjectionsResponse: (state, action) => {
      state.editProjectionsResponse = action.payload;
    },
    setProjectionsData: (state, action) => {
      state.projectionsData = action.payload;
    },
    setMoneySourceDetailsValues: (state, action) => {
      state.moneySourceDetailsValues = action.payload;
    },
    setSpouseDetailsInStore: (state, action) => {
      state.spouseDetails = action.payload;
    },
    resetOwnersState: (state) => {
      state.ownerSearchParams = null;
      state.searchProductOwnershipResult = null;
      state.ownershipInquiryResult = null;
      state.selectedOwner = null;
      state.asOfBalanceAccountData = null;
      state.accountValueDatasource = null;
      state.hasSearchedForAsOfBalanceAccountData = false;
      state.editProjectionsResponse = null;
      state.projectionsData = [];
      state.moneySourceDetailsValues = null;
      state.spouseDetails = null;
      state.transactionDetailsForDateRange = null;
    },
  },
});

export const {
  setOwnerSearchParams,
  setSearchProductOwnershipResult,
  setOwnershipInquiryResult,
  setSelectedOwner,
  setAsOfBalanceAccountData,
  setAccountValueDataSource,
  setHasSearchedForAsOfBalanceAccountData,
  setTransactionDetailsForDateRange,
  setEditProjectionsResponse,
  setProjectionsData,
  setMoneySourceDetailsValues,
  setSpouseDetailsInStore,
  resetOwnersState,
} = ownersSlice.actions;
export default ownersSlice.reducer;
